/* eslint-disable global-require */
/// <reference types="@welldone-software/why-did-you-render" />

import * as React from 'react'

import { NodeEnvEnum } from 'Types/env.types'

if (process.env.NODE_ENV === NodeEnvEnum.DEV) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require('@welldone-software/why-did-you-render')

  whyDidYouRender(React, {
    collapseGroups: true,
    trackAllPureComponents: true,
  })
}
